module.exports = __webpack_public_path__ + "static/media/pencil.8100ec7d.svg";